import React, { useState } from 'react';
import { ProcessReturnDetail } from '../callCenterReturnsDisputesTypes';
import { PriorityBadge } from '../../shared';
import styles from './ProcessReturnPanel.module.css';

interface ProcessReturnPanelProps {
  detail: ProcessReturnDetail;
  onApprove?: (notes: string, condition: string) => Promise<void> | void;
  onReject?: (notes: string, condition: string) => Promise<void> | void;
  busy?: boolean;
}

export const ProcessReturnPanel: React.FC<ProcessReturnPanelProps> = ({ detail, onApprove, onReject, busy }) => {
  const [condition, setCondition] = useState('');
  const [notes, setNotes] = useState('');

  return (
    <div className={styles.panel}>
      <div className={styles.headerRow}>
        <h3 className={styles.title}>Process Return — {detail.ticketId}</h3>
        <span className={styles.priorityWrap}>
          <PriorityBadge priority={detail.priority} />
        </span>
      </div>

      <div className={styles.body}>
        <div className={styles.left}>
          <h4 className={styles.subhead}>Return Details</h4>
          <div className={styles.detailRow}>
            <span className={styles.label}>Order</span>
            <span className={styles.value}>{detail.order}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.label}>Customer</span>
            <span className={styles.value}>{detail.customer}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.label}>Return Reason</span>
            <span className={`${styles.value} ${styles.danger}`}>{detail.returnReason}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.label}>Item</span>
            <span className={styles.value}>{detail.item}</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.label}>Condition</span>
            <span className={`${styles.value} ${styles.danger}`}>{detail.condition}</span>
          </div>

          <h4 className={`${styles.subhead} ${styles.spaced}`}>Condition Photos</h4>
          <div className={styles.photos}>
            <div className={styles.photoBox}>
              <span className={styles.photoIcon}>📷</span>
              <span className={styles.photoLabel}>Photo 1</span>
            </div>
            <div className={styles.photoBox}>
              <span className={styles.photoIcon}>📷</span>
              <span className={styles.photoLabel}>Photo 2</span>
            </div>
          </div>
        </div>

        <div className={styles.right}>
          <h4 className={styles.subhead}>Assessment & Decision</h4>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>Condition Assessment</label>
            <select
              className={styles.select}
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
            >
              <option value="">Select...</option>
              <option>Damaged - Approve return</option>
              <option>Resealable - Approve restock</option>
              <option>Acceptable - Reject return</option>
            </select>
          </div>

          <div className={styles.field}>
            <label className={styles.fieldLabel}>Resolution Notes</label>
            <textarea
              className={styles.textarea}
              rows={5}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.approveBtn}
              onClick={() => onApprove?.(notes, condition)}
              disabled={busy}
            >
              {busy ? 'Working…' : '✓ Approve Return'}
            </button>
            <button
              type="button"
              className={styles.rejectBtn}
              onClick={() => onReject?.(notes, condition)}
              disabled={busy}
            >
              ✕ Reject Return
            </button>
          </div>

          <div className={styles.note}>
            Inventory adjustment will be handled automatically by Warehouse after approval.
          </div>
        </div>
      </div>
    </div>
  );
};
